<!--
 * @Author: Merlin
 * @Date: 2023-12-06 18:12:16
 * @LastEditors: Merlin
 * @LastEditTime: 2025-05-16 13:58:10
 * @Description: 
-->
<template>
    <span class="crash-jackpot" >
        <span class="crash-jackpot__label">
            Jackpot
        </span>
        <span class="jackpot__currency">
            <ClientOnly>
                {{handleExchangeRate(jackpotSize)?.toFixed(0)}}
                {{ currentCurrency.toLocaleUpperCase() }}
            </ClientOnly>
        </span>
    </span>
</template>

<script>
import useSettingsStore from '@/stores/settings';
export default {
    props: {
        jackpotSize: {
            type: Number,
            default: 0
        }
    },
    computed: {
        currentCurrency(){
            return useSettingsStore().pickedCurrency || 'btc';
        }
    },
}
</script>

<style lang="scss" scoped>
// ▼头奖金额
.crash-jackpot{
    display: flex;
    justify-content: center;
    flex-wrap: nowrap;
    flex-direction: row;
    user-select: none;
    cursor: pointer;
}

.crash-jackpot__label{
    background-image: linear-gradient(135deg,#f87c2a 30%,#f3be7d 50%,#f87c2a 70%);
    -webkit-text-fill-color: transparent;
    background-size: 200% auto;
    display: block;
    text-transform: uppercase;
    background-clip: text;
    font-size: 16px;
    font-weight: 800;
}
.jackpot__currency{
    white-space: nowrap;
    font-size: 15px;
    font-weight: 800;
    margin: 0 0 0 0.6em;
}

</style>>
